import { render, staticRenderFns } from "./ModalFormsPage.vue?vue&type=template&id=07550af8&"
import script from "./ModalFormsPage.vue?vue&type=script&lang=js&"
export * from "./ModalFormsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports